<div class="from_group paginator_group">
<mat-paginator
  [length]="recordsLength"
  [pageSize]="pageSize"
  [pageSizeOptions]="[ 5, 10, 25, 100]"
  (page)="handlePage($event)"
></mat-paginator>
</div>